import { faSpinner } from '@fortawesome/fontawesome-free-solid';
import classNames from 'classnames';
import { Set as ImmutableSet } from 'immutable';
import jsPDF from 'jspdf';
import autoTable from 'jspdf-autotable';
import moment from 'moment';
import { pipe } from 'ramda';
import React, { FC, useEffect } from 'react';
import { GoogleMap } from 'react-google-maps';
import { MAP } from 'react-google-maps/lib/constants';
import { connect, DispatchProp, useDispatch, batch } from 'react-redux';
import { RouteComponentProps, withRouter } from 'react-router-dom';
import Select from 'react-select';
// import { toast } from 'react-toastify';
import { ReactComponent as CloseIcon } from '../../../assets/svg/close-icon.svg';

import { compose } from 'redux';

import { BaseComponent } from '../../../shared/BaseComponent';
import { ACL, SECONDS_IN_DAY, UserCan } from '../../../shared/constants';
import { getAuditLog, getGeonfeces, getHideLargeReportWarning, getTrip, getTrips, iGetReportPropsWrapper, makeTripFromEndpointData, tripPointsReal } from '../../../shared/db/report-db';
import {
    friendlyDiff,
    friendlyMilesPer,
    friendlySpeed,
    idValArr,
    isMobile,
    lCount,
    minutesToFriendly,
    userCurrentOffset,
    utcOffset,
    vals
} from '../../../shared/helpers';
import {
    beToken,
    iDevicePing,
    iFullStoreState,
    iList,
    iPerson,
    iTag,
    iTrip
} from '../../../shared/interfaces';
import { localStorage } from '../../../shared/storage';
import { DevicesDetailsContainer, DevicesLastPingContainer } from '../../../stores/reducers/devicesData';
import {
    setReportTrip,
    toggleShowReportTrip,
    hideReportTrips
} from '../../../stores/reducers/devicesTripsPoints/AC';
import { IReducerDevicesTripsPoints } from '../../../stores/reducers/devicesTripsPoints/index';
import { iGMapModal } from '../../../stores/reducers/gMapModal';
import { GMapModalAC, GMapModalContent } from '../../../stores/reducers/gMapModal/AC';
import { Actions as MapActions } from '../../../stores/reducers/gmap-reducers';
import { setActiveDeviceId } from '../../../stores/reducers/replay/AC';
import {
    iChoosingDetails, IFilterValue,
    iReportDetails,
    iState as iReportState,
    iReportType,
    iTripsFromSelectedArea,
    recordMatches,
    Actions as ReportActions
} from '../../../stores/reducers/report-reducers';
import { Button, ButtonSize, ButtonStyles } from '../../Button';
import DashboardBlock from '../../DashboardBlock';
import Dialog, { DialogConfigSetter } from '../../Dialog';
import { Fa } from '../../elements/fa';
import MinimalTile from '../../general/MinimalTile';
import { PersonBox } from '../../general/person-box';
import { LabelChooser } from '../../general/trip-list-chooser';
import { Overlay } from '../../menus/modal/modal';
import AuditReport from './AuditReport';
import GeofenceReport from './GeofenceReport';
import { ReportNavbar } from './ReportNavbar';
import TripTravelTablePure from './ReportPage/TripTravelTablePure';
import SummaryReport from './SummaryReport';
import VideoReport from './VideoReport';
// import FilterIndicators from './FilterIndicators';
import axios, { CancelTokenSource } from 'axios';
import instance from '../../../api/instance';
import { VideoReportBody } from '../../../shared/apis.interfaces';
import { makePointFromEndpointData } from '../../../shared/db/report-db';
import { clientDb, clientStore } from '../../../shared/firebase';
import LongReportModal from '../../LongReportModal';
import ActivityReport from './ActivityReport';
import { getFilteredData } from './AuditReport/helper';
import {
    compareArrays,
    formatAlertWithHas,
    formattingData,
    getActivityReports,
    getDeviceName,
    getDevicesFromTag,
    getPermissionsForUsers
} from './report-utils';
import { filterRecords, validate } from './reportFilter';
import LocalModalActions from './ReportPage/LocalModalActions';

import '../../../assets/styles/classes.scss';
import './ReportPage.scss';
import './shared.scss';
import './styles.scss';

import { ReactComponent as ChevronLeft } from '../../../assets/svg/chevron_left.svg';
import { ReactComponent as ChevronRight } from '../../../assets/svg/chevron_right.svg';
import { ReactComponent as FilterListSvg } from '../../../assets/svg/filter_list.svg';
import { customSelectStyles } from '../../general/selections-grid/constants';
import ModalHeaderComponent from '../../menus/modal/modal-header';
import DateFilterTabs, { DateChangeType } from './DateFilterTabs/DateFilterTabs';
import MileageReport from "./MileageReport";
import { FilterType } from './ReportPageFilters/ReportPageFilters.interfaces';
import ReportTripDetailsModal from './ReportTripDetailsModal';
import { DashboardSize } from '../../../stores/reducers/dashboardInfo';

const NativeSet = globalThis.Set;

type IProps = RouteComponentProps<{ type?: 'static' | 'travel' }>;

type IPropsFromStore = {
    report: iReportDetails,
    dates: any,
    devicesDetails: DevicesDetailsContainer;
    devicesLastPing: DevicesLastPingContainer;
    people: iList<iPerson>,
    userToken?: beToken;
    tags: iList<iTag>,
    tagDevices: { [key: string]: ImmutableSet<string>; },
    choosing?: iChoosingDetails;
    labels: string[],
    displayRecords: iList<iTrip | iDevicePing>,
    reportType: iReportType,
    reportTypeFromRedux: iReportType,
    userCanDo: UserCan[],
    tripsFromSelectedArea: iTripsFromSelectedArea,
    filterDisplayRecords: Array<IFilterValue>
    selectionsList: [],
    filters: any,
    mapRef: React.RefObject<GoogleMap>,
    selectedDevices: any,
    devicesTripsPoints: IReducerDevicesTripsPoints,
    size: DashboardSize,
    accessToken: string,
    travelTripIds: string[],
}

type IFullProps = IProps & IPropsFromStore & DispatchProp;
const mapStateToProps = (state: iFullStoreState, ownProps): IPropsFromStore => {
    const reportTypeRedux = typeof state.report.details.reportTypeFromRedux == 'undefined' ? 'travel' : state.report.details.reportTypeFromRedux;
    return ({
        selectedDevices: state.report.details.filters.device || {},
        userToken: state.auth.user?.beToken,
        displayRecords: state.report.displayRecords ?? {},
        choosing: state.report.choosing,
        dates: state.report.details.dates,
        devicesDetails: state.devicesData.devicesDetails,
        devicesLastPing: state.devicesData.devicesLastPing,
        people: state.general.people,
        report: state.report.details,
        tripsFromSelectedArea: state.report.details.tripsFromSelectedArea,
        labels: state.general.tripLabels,
        tags: state.general.tags,
        tagDevices: state.tagsDevicesMap.tagsDevices.toObject(),
        reportType: ownProps.match.params.type, // it takes report type from url
        reportTypeFromRedux: reportTypeRedux, // it takes report type from redux
        userCanDo: state.auth.user?.acl?.can ?? [],
        filterDisplayRecords: state.report.filterDisplayRecords,
        selectionsList: state.report.selectionsList,
        filters: state.report.details.filters,
        mapRef: state.gmap.mapRef(),
        devicesTripsPoints: state.devicesTripsPoints,
        size: state.dashboardInfo.size,
        accessToken: state.billing.token.access_token,
        travelTripIds: state.report.travelTripIds || [],
    })
}

type PageLastDocs = {
    [key: number]: string | null;
};

type IState = {
    lastRequestId: number;
    loading: boolean;
    paginationLoading: boolean;
    showNewReport: boolean;
    records: object;
    reportData: object;
    showAllRoute: boolean;
    showVisibleReportData: boolean;
    showVisibleFencesData: boolean;
    allTrips: any;
    disablePaginateButton: {
        disableNextButton: boolean, disablePreviousButton: boolean
    }
    isHaveNext: boolean,
    travelCurrentPage: number,
    travelIsLastPage: boolean,
    travelLastDocs: PageLastDocs,
    prevStartFrom: null | string,
    prevSearchKey: string,
    currentPage: number,
    videoTotalCount: number,
    videoRequestBody?: VideoReportBody,
    pages: any,
    auditLog: object,
    isLongReport: boolean,
    popupCloseHandler: () => void | null,
    popupProceedHandler: () => void | null,
    staticCurrentDay: number,
    staticMaxDay: number | null,
    staticCurrentPage: number,
    staticMaxPage: number | null,
    staticLimitPerPage: number,
    staticDirection: boolean,
    staticCurrentDeviceIdx: number,
    staticDevices: string[],
    staticCurrentDeviceName: string,
    isStaticDayPagination: boolean,
    cancelTokenSource: CancelTokenSource,
    showLargeReportWarning: boolean,
    dateUnstaged?: Array<{startDate: moment.Moment | null, endDate: moment.Moment | null}> | null,
    timeEnd: moment.Moment | null,
    mileageClient: string,
    mileageStartDate: number | null,
    mileageEndDate: number | null,
    mileagePageLimit: number,
    mileageDevices: string[],
    datesState: {
        isDirty: boolean,
    },
    isShowingAllTrips: boolean,
    isLoadingAllTrips: boolean,
    showAllTripsScope: 'page' | 'result-set',
    showAllTripsDropdownOpen: boolean,
}

const disabledButton = {
    disableNextButton: false,
    disablePreviousButton: true,
}

class ReportPage extends BaseComponent<IFullProps, IState> {
    constructor(props) {
        super(props);

        this.handleVisReportClick = this.handleVisReportClick.bind(this);
    }

    private dialog: DialogConfigSetter;

    isRequesting = false;

    state: IState = {
        lastRequestId: null,
        loading: false,
        paginationLoading: false,
        showNewReport: true,
        records: {},
        reportData: {},
        showAllRoute: false,
        showVisibleReportData: false,
        showVisibleFencesData: false,
        allTrips: [],
        disablePaginateButton: disabledButton,
        isHaveNext: false,
        travelCurrentPage: 1,
        travelIsLastPage: false,
        travelLastDocs: {1: null},
        prevStartFrom: '',
        prevSearchKey: '',
        currentPage: 1,
        videoTotalCount: 0,
        pages: [],
        auditLog: {},
        isLongReport: false,
        popupCloseHandler: null,
        popupProceedHandler: null,
        staticCurrentDay: 1,
        staticMaxDay: null,
        staticCurrentPage: 1,
        staticMaxPage: null,
        staticLimitPerPage: 20,
        staticDirection: true,
        staticCurrentDeviceIdx: 0,
        staticDevices: [],
        staticCurrentDeviceName: '',
        isStaticDayPagination: true,
        cancelTokenSource: null,
        showLargeReportWarning: false,
        dateUnstaged: [],
        mileageClient: '',
        mileageStartDate: null,
        mileageEndDate: null,
        mileagePageLimit: 3,
        mileageDevices: [],
        datesState: {
            isDirty: false,
        },
        timeEnd: null,
        isShowingAllTrips: false,
        isLoadingAllTrips: false,
        showAllTripsScope: 'page',
        showAllTripsDropdownOpen: false,
    };

    showPopup = (showLargeReportWarning: boolean) => {
        return new Promise((resolve) => {
            const handlePopupProceed = () => {
                this.setState({isLongReport: false});
                resolve(true);
            }

            const handlePopupClose = () => {
                this.setState({isLongReport: false});
                resolve(false);
            }

            if (showLargeReportWarning) {
                this.setState({isLongReport: true});
            }
            else {
                handlePopupProceed();
            }

            this.setState({popupProceedHandler: handlePopupProceed, popupCloseHandler: handlePopupClose});
        })
    }

    getTripQuery = ({ collectionName = 'trips', filters = {}, dates: { minStartDate, maxEndDate } }) => {
        const filtersKeys = Object.keys(filters);

        let query = clientStore().collection(collectionName)
            .where('startDate', '>=', minStartDate.clone().add(userCurrentOffset, 'hours').toDate())
            .where('startDate', '<', maxEndDate.clone().add(userCurrentOffset, 'hours').toDate())

        const getFirebaseQueryParams = ({ filterType, selectedFilterValue }) => {
            const { filterName, filterValue } = selectedFilterValue;

            let obj = { name: '', value: '' }
            switch (filterType) {
                case 'alerts': {
                    obj.name = `alertActivity.has${filterName.toLowerCase()}`
                    obj.value = filterValue;
                    break;
                }
                case 'device': {
                    obj.name = filterType
                    obj.value = filterName;
                    break;
                }
                // TODO need to fix it
                case 'tag': {
                    obj.name = 'device'
                    obj.value = filterValue;
                    break;
                }
                case 'labels': {
                    obj.name = 'label'
                    obj.value = filterValue;
                    break;
                }
                case 'person': {
                    obj.name = 'personId'
                    obj.value = filterName;
                    break;
                }

                default:
                    break;
            }
            return obj
        }

        if (filtersKeys.length) {
            Object.entries(filters).forEach(([filterType, filter]) => {
                if (filterType === 'tag') {
                    filterType = 'device';
                    filter = Object.entries(filter).reduce((prev, [keyName]) => {
                        const deviceIds = (this.props.tagDevices?.[keyName] as ImmutableSet<string>);

                        if (!deviceIds) return prev;

                        deviceIds?.forEach((value) => {
                            Object.assign(prev, { [value]: true })
                        })

                        return prev;
                    }, {})
                }

                let multiValues = [];
                let obj = { filterName: '', filterValue: null }
                const countOfSelectedFilters = Object.keys(filter).length;
                const moreThanOneFilter = countOfSelectedFilters > 1;
                const dynamicOperator = moreThanOneFilter ? 'in' : '==';

                Object.entries(filter).forEach(([keyName, value]) => {
                    if (moreThanOneFilter) {
                        multiValues.push(keyName);
                    } else {
                        obj.filterName = keyName;
                        obj.filterValue = value;
                    }
                });

                const { name: queryFieldName, value: queryFieldValue } = getFirebaseQueryParams({ filterType, selectedFilterValue: obj });
                let dynamicValue = moreThanOneFilter ? multiValues : queryFieldValue;

                if (queryFieldName && dynamicOperator && dynamicValue) {
                    const dynamicValueLenght = dynamicValue?.length

                    if (moreThanOneFilter && dynamicValueLenght > 10) {
                        query = query.where(queryFieldName, dynamicOperator, dynamicValue.slice(0, 10));
                    } else {
                        query = query.where(queryFieldName, dynamicOperator, dynamicValue);
                    }
                }
            });
        }

        return query;
    };

    travelTabQuery = async (props) => {
        const { next, previous, dates, filters } = props;
        const { dispatch } = this.props;
        const TRAVEL_LIMIT = 500;

        let minUtcOffset = 0;
        let maxUtcOffset = 0;

        if (filters.tag) {
            const tags = Object.keys(filters.tag);
            const devicesUtcOffset: Array<number> = [];

            for (const tag of tags) {
                const tagDevices = [];
                const tagDevicesSnapshot = await clientDb().child(`tags/${tag}/instances/device`).once('value');
                const tagDevicesSnapshotValue = tagDevicesSnapshot.val();

                tagDevices.push(...Object.keys(tagDevicesSnapshotValue))

                for (const device of tagDevices) {
                    const tagDevicesSnapshot = await clientDb().child(`devices/device-details/${device}`).once('value');
                    const tagDevicesSnapshotValue = tagDevicesSnapshot.val();

                    const utcOffset = moment.tz(tagDevicesSnapshotValue.timezone).utcOffset() / 60;
                    devicesUtcOffset.push(utcOffset);
                }
            }

            minUtcOffset = Math.min(...devicesUtcOffset);
            maxUtcOffset = Math.max(...devicesUtcOffset);
        }

        const minStartDate = dates.map(({ startDate }) => startDate).reduce((c, d): moment.Moment => !c || d.clone().isBefore(c) ? d.clone() : c.clone(), 0 as any);
        const maxEndDate = dates.map(({ endDate }) => endDate).reduce((c, d): moment.Moment => !c || d.clone().isAfter(c) ? d.clone() : c.clone(), 0 as any);
        const userCurrentOffset = parseInt(moment().format('ZZ')) / 100;

        let defaultQuery = this.getTripQuery({
            filters,
            dates: {
                minStartDate: minUtcOffset < 0 ? minStartDate.add(minUtcOffset, 'hours') : minStartDate,
                maxEndDate: maxUtcOffset > 0 ? maxEndDate.add(maxUtcOffset, 'hours') : maxEndDate,
            }
        });

        const findTripIdsInTrips = (arrayOfTripIdsThatAreInTheSelectedArea, trips) => {
            const tripsInTheSelectedAre = {};

            arrayOfTripIdsThatAreInTheSelectedArea.forEach(tripId => {
                if (trips[tripId]) {
                    tripsInTheSelectedAre[tripId] = trips[tripId];
                }
            });

            return tripsInTheSelectedAre;
        }

        if (next && this.state.allTrips.length) {
            const lastVisible = this.state.allTrips[this.state.allTrips.length - 1];

            const nextQuery = defaultQuery?.startAfter(lastVisible)?.limit(TRAVEL_LIMIT);
            const nextData = (await nextQuery.get())?.docs;

            if (nextData && nextData.length > 0) {
                const data = formattingData(nextData);
                dispatch(ReportActions.SET_DISPLAY_RECORDS(data));

                this.setState(prevState => ({
                    allTrips: nextData,
                    currentPage: prevState.currentPage + 1,
                    disablePaginateButton: {
                        disableNextButton: false,
                        disablePreviousButton: false,
                    }
                }));

                const lastVisibleForCheck = nextData[nextData.length - 1];
                const checkNextData = (await defaultQuery?.startAfter(lastVisibleForCheck)?.limit(1).get())?.docs;

                this.setState({ isHaveNext: !!checkNextData && checkNextData.length > 0 });

            } else {
                this.setState(prevState => ({
                    disablePaginateButton: {
                        ...prevState.disablePaginateButton,
                        disableNextButton: true,
                    },
                    isHaveNext: false
                }));
                // toast.error('There is no more data');
            }

            this.setState({ loading: false });

        } else if (previous && this.state.allTrips.length) {
            const prevVisible = this.state.allTrips[0];

            const previousQuery = defaultQuery.orderBy('startDate').endBefore(prevVisible).limitToLast(TRAVEL_LIMIT);
            const previousData = (await previousQuery.get()).docs;

            if (previousData && previousData.length > 0) {
                const data = formattingData(previousData);
                dispatch(ReportActions.SET_DISPLAY_RECORDS(data));

                this.setState(prevState => ({
                    allTrips: previousData,
                    currentPage: prevState.currentPage - 1,
                    disablePaginateButton: {
                        disableNextButton: false,
                        disablePreviousButton: prevState.currentPage - 1 <= 1
                    },
                    isHaveNext: true
                }));
            } else {
                this.setState({ loading: false });
                // toast.error('There is no previous data');
            }
            this.setState({ loading: false });

        } else {
            let firstData;
            let data;

            if (this.props.tripsFromSelectedArea?.uniqueTripPath?.length !== 0 && this.props.tripsFromSelectedArea?.isSelectedAreaMode === true) {
                firstData = (await defaultQuery.get()).docs;
                data = formattingData(firstData);

                const arrayOfTripIdsThatAreInTheSelectedArea = this.props.tripsFromSelectedArea?.uniqueTripPath;
                const selectedAreaData = findTripIdsInTrips(arrayOfTripIdsThatAreInTheSelectedArea, data);

                dispatch(ReportActions.SET_DISPLAY_RECORDS(selectedAreaData));

            } else {
                const first = defaultQuery.limit(TRAVEL_LIMIT);
                firstData = (await first.get()).docs;
                data = formattingData(firstData);
                dispatch(ReportActions.SET_DISPLAY_RECORDS(data));
            }

            this.setState({
                allTrips: firstData,
                loading: false,
                currentPage: 1,
                disablePaginateButton: {
                    disableNextButton: false,
                    disablePreviousButton: true,
                }
            });

            if (firstData.length > 0) {
                const lastVisibleForCheck = firstData[firstData.length - 1];
                const checkNextData = (await defaultQuery?.startAfter(lastVisibleForCheck)?.limit(1).get())?.docs;
                this.setState({ isHaveNext: !!checkNextData && checkNextData.length > 0 });
            } else {
                this.setState({ isHaveNext: false });
            }
        }
    };
    setShowAllRoute = (bool: boolean) => this.setState({ showAllRoute: bool });

    getRecords = (data) => {
        this.setState({ records: { ...data } });
    }

    getNames = (data) => {
        const users = Object.keys(data)
        users.map(user => {
            this.setState(prevState => {
                return {
                    reportData: { ...prevState.reportData, [user]: { ...prevState.reportData[user], name: data[user] } },
                }
            })
        })
    }

    showReportTrip = async (item, tripPoints, zoomToTrip?: boolean) => {
        const { dispatch, mapRef } = this.props;

        if (this.state.isShowingAllTrips) {
            dispatch(hideReportTrips());
            this.setState({ isShowingAllTrips: false });
        }

        // Set the active device ID for replay controls
        dispatch(setActiveDeviceId(item.device));

        if (!tripPoints?.getIn([item.device, 'tripsPoints', item.tripId])) {
            try {
                const points: iDevicePing[] = Object.values((await tripPointsReal(item.tripId)));

                dispatch(setReportTrip(item.device, item.tripId, points));

                if (zoomToTrip && points.length > 0) {
                    const coordinates = points.reduce((prev, curr) => {
                        const { lat, lng } = curr.coordinates.location;

                        return {
                            latMin: Math.min(lat, prev.latMin),
                            latMax: Math.max(lat, prev.latMax),
                            lngMin: Math.min(lng, prev.lngMin),
                            lngMax: Math.max(lng, prev.lngMax),
                        }
                    }, {
                        latMin: Number.MAX_SAFE_INTEGER,
                        latMax: Number.MIN_SAFE_INTEGER,
                        lngMin: Number.MAX_SAFE_INTEGER,
                        lngMax: Number.MIN_SAFE_INTEGER,
                    });

                    const latlngList: google.maps.LatLng[] = [
                        new google.maps.LatLng(coordinates.latMax, coordinates.lngMax),
                        new google.maps.LatLng(coordinates.latMin, coordinates.lngMin)
                    ];

                    const bounds = new google.maps.LatLngBounds();
                    latlngList.forEach(n => bounds.extend(n));

                    const map = mapRef.current!.context[MAP] as google.maps.Map;
                    map.setCenter(bounds.getCenter());
                    map.fitBounds(bounds);
                }

                dispatch(toggleShowReportTrip(item.device, item.tripId, true));
            } catch (error) {
                console.error("Error handling trip points:", error);
            }
        } else {
            dispatch(toggleShowReportTrip(item.device, item.tripId, true));
        }
    }

    hideReportTrip = (item) => {
        const { dispatch } = this.props;
        dispatch(toggleShowReportTrip(item.device, item.tripId, false));
    }

    showAllTrips = async (scope: 'page' | 'result-set' = 'page') => {
        const { dispatch, displayRecords, travelTripIds } = this.props;

        this.setState({ isLoadingAllTrips: true });
        dispatch(hideReportTrips());
        dispatch(MapActions.SET_REPORT_LINES(false));
        dispatch(setActiveDeviceId(null));

        try {
            const pageTrips = idValArr(displayRecords)
                .map(({ val: trip }) => ({ tripId: trip?.tripId, device: trip?.device }))
                .filter(({ tripId, device }) => !!tripId && !!device);

            let tripsToLoad: Array<{ tripId: string, device: string }> = pageTrips;

            if (scope === 'result-set' && Array.isArray(travelTripIds) && travelTripIds.length) {
                const pageTripsById = pageTrips.reduce((acc, item) => {
                    acc[item.tripId] = item;
                    return acc;
                }, {} as Record<string, { tripId: string, device: string }>);

                const uniqueTripIds = Array.from(new NativeSet(travelTripIds));
                const resolvedTrips: Array<{ tripId: string, device: string }> = [];
                const resolveChunkSize = 20;

                for (let index = 0; index < uniqueTripIds.length; index += resolveChunkSize) {
                    const chunk = uniqueTripIds.slice(index, index + resolveChunkSize);
                    const chunkResults = await Promise.all(chunk.map(async tripId => {
                        if (pageTripsById[tripId]) return pageTripsById[tripId];

                        try {
                            const fullTrip = await getTrip(tripId);
                            if (!fullTrip?.tripId || !fullTrip?.device) return null;
                            return { tripId: fullTrip.tripId, device: fullTrip.device };
                        } catch (error) {
                            console.error(`Failed to resolve trip ${tripId}:`, error);
                            return null;
                        }
                    }));

                    resolvedTrips.push(...chunkResults.filter(Boolean) as Array<{ tripId: string, device: string }>);
                }

                tripsToLoad = resolvedTrips;
            }

            const uniqueTripsToLoad = Array.from(new NativeSet(tripsToLoad.map(({ tripId }) => tripId)))
                .map(tripId => tripsToLoad.find(trip => trip.tripId === tripId))
                .filter(Boolean) as Array<{ tripId: string, device: string }>;

            // Load trips in chunks and batch Redux updates to prevent excessive re-renders
            const loadChunkSize = 10;
            for (let index = 0; index < uniqueTripsToLoad.length; index += loadChunkSize) {
                const chunk = uniqueTripsToLoad.slice(index, index + loadChunkSize);

                const chunkResults = await Promise.all(chunk.map(async ({ tripId, device }) => {
                    try {
                        const points: iDevicePing[] = Object.values(await tripPointsReal(tripId));
                        return { tripId, device, points };
                    } catch (error) {
                        console.error(`Failed to load trip ${tripId}:`, error);
                        return null;
                    }
                }));

                // Batch all Redux dispatches for this chunk into a single update
                batch(() => {
                    chunkResults.forEach((result) => {
                        if (result) {
                            dispatch(setReportTrip(result.device, result.tripId, result.points));
                            dispatch(toggleShowReportTrip(result.device, result.tripId, true));
                        }
                    });
                });

                // Yield to browser for rendering/user interaction between chunks
                await new Promise(resolve => setTimeout(resolve, 0));
            }

            dispatch(setActiveDeviceId(null));

            this.setState({
                isShowingAllTrips: true,
            });
        } finally {
            this.setState({
                isLoadingAllTrips: false,
            });
        }
    }

    hideAllTrips = () => {
        const { dispatch } = this.props;

        dispatch(hideReportTrips());
        dispatch(MapActions.SET_REPORT_LINES(true));
        dispatch(setActiveDeviceId(null));

        this.setState({ isShowingAllTrips: false });
    }

    getReportData = (data) => {
        // const { dispatch } = this.props;
        this.setState(prevState => {
            return {
                reportData: { ...prevState.reportData, ...data },
            }
        })
    }

    private toggleDevicePerson = (type: 'device' | 'person') => () => pipe(ReportActions.SET_DEVICE_PERSON, this.props.dispatch)(type)

    handleVisReportClick = () => {
        this.setState(prevState => {
            return {
                ...prevState,
                showVisibleReportData: !prevState.showVisibleReportData
            }
        })
    }

    handleVisFencesClick = () => {
        this.setState(prevState => {
            return {
                ...prevState,
                showVisibleFencesData: !prevState.showVisibleFencesData
            }
        })
    }

    pageClick = ({ next, previous, dates, filters }) => {
        this.setState({ loading: true });
        this.travelTabQuery({ next, previous, dates, filters });
    }

    populateData = async (props: IFullProps) => {
        await this.fetchHideLargeReportWarning();
        const { devicesDetails, report, tags, dispatch, userToken, filters } = props;
        const {showLargeReportWarning} = this.state;
        const dateIsRequired = report.reportType !== 'permissions' && report.reportType !== 'video' && report.reportType !== 'activity';
        const startDate = report.dates[0]?.startDate || null;
        const endDate = report.dates[0]?.endDate || null;
        const devicesLength = props.filters.device ? Object.keys(props.filters.device).length : 0;
        const longerThenWeek = (startDate && endDate) ? endDate.diff(startDate, 'seconds') > SECONDS_IN_DAY * 7 : false;
        const shouldShowPopup = devicesLength > 25 || longerThenWeek;
        const isBookmark = report.reportSearchKey ? true : false;

        dispatch(ReportActions.SET_SEARCH_KEY(null));

        if (shouldShowPopup && ['travel', 'static', 'geofence', 'summary'].includes(report.reportType)) {
            const shouldProceed = await this.showPopup(showLargeReportWarning);
            if (!shouldProceed) return;
        }

        if (!report.reportType && !report.searchKey) return;

        if (report.dates.length === 0 && dateIsRequired) return;

        if (report.reportType) {
            this.setState({ loading: true });
        }

        const newGetPointsFromBackend = async () => {
            if (this.isRequesting) {
                return;
            }

            const devices = await fetchStaticDevices();

            if (devices.length === 0) {
                this.setState({
                    loading: false
                });

                this._clearRecords();

                return;
            }

            this.setState({staticDevices: [...devices]});

            this.isRequesting = true;

            const URL = `/api/firestore/get-points`;
            const clientId = localStorage.get('active-client');

            const body = {
                limit: this.state.staticLimitPerPage,
                page: this.state.staticCurrentPage,
                day: this.state.staticCurrentDay,
                ...(this.state.isStaticDayPagination && this.state.staticDirection !== null
                  ? { direction: Number(this.state.staticDirection) }
                  : {}),
                start_time: moment(report.dates[0].startDate).unix(),
                end_time: moment(report.dates[0].endDate).unix(),
                organization_key: clientId,
                posted_speed: filters.posted_speed || false,
                device: devices[this.state.staticCurrentDeviceIdx],
                ...(filters.person && {
                    people: Object.keys(filters.person)
                }),
                ...(filters.alerts && {
                    alert: Object.keys(filters.alerts).map(alert => formatAlertWithHas(alert))[0]
                }),
                ...(filters.labels && {
                    labels: Object.keys(filters.labels)
                }),
                ...(filters.values && {
                    address: {
                        ...(filters.values?.city && {
                            city: {
                                condition: filters.values?.city?.condition,
                                value: filters.values?.city?.value
                            }
                        }),
                        ...(filters.values?.state && {
                            state: {
                                condition: filters.values?.state?.condition,
                                value: filters.values?.state?.value
                            }
                        }),
                        ...(filters.values?.street && {
                            street: {
                                condition: filters.values?.street?.condition,
                                value: filters.values?.street?.value
                            }
                        }),
                        ...(filters.values?.zip && {
                            zip: {
                                condition: filters.values?.zip?.condition,
                                value: filters.values?.zip?.value
                            }
                        }),
                    },
                    metric: {
                        ...(filters.values?.fuel && {
                            fuel: {
                                condition: filters.values?.fuel?.condition,
                                value: filters.values?.fuel?.value
                            }
                        }),
                        ...(filters.values?.mpg && {
                            mpg: {
                                condition: filters.values?.mpg?.condition,
                                value: filters.values?.mpg?.value
                            }
                        }),
                        ...(filters.values?.rpm && {
                            rpm: {
                                condition: filters.values?.rpm?.condition,
                                value: filters.values?.rpm?.value
                            }
                        }),
                        ...(filters.values?.speed && {
                            speed: {
                                condition: filters.values?.speed?.condition,
                                value: filters.values?.speed?.value
                            }
                        }),
                        ...(filters.values?.volts && {
                            volts: {
                                condition: filters.values?.volts?.condition,
                                value: filters.values?.volts?.value
                            }
                        }),
                    }
                })
            }

            try {
                const {data} = await instance.post(URL, {...body});

                if (data.length === 0) {
                    this._clearRecords();

                    this.setState({
                        loading: false
                    });

                    return;
                }

                const rawRecords = data.data;

                let formattedPoints: any = [];

                for (const point of rawRecords) {
                    formattedPoints[point.pointId] = makePointFromEndpointData(point);
                }

                await dispatch(ReportActions.SET_DISPLAY_RECORDS(formattedPoints));

                const deviceName = await getDeviceName(devices[this.state.staticCurrentDeviceIdx]);

                this.setState({
                    loading: false,
                    staticMaxPage: data['total_page'],
                    staticCurrentDay: data['current_day'],
                    staticCurrentDeviceName: deviceName
                });

                this.isRequesting = false;

                return data['total_days'];
            }
            catch (e) {
                this.setState({ loading: false });
                console.log(e)
                this.isRequesting = false;
            }
        }

        const getPointsFromBackend = async (page) => {
            const URL = `/api/firestore/points-with-filter`;
            const clientId = localStorage.get('active-client');

            const body = {
                address: {
                    ...(filters.values?.city && {
                        city: filters.values.city
                    }),
                    ...(filters.values?.state && {
                        state: filters.values.state
                    }),
                    ...(filters.values?.street && {
                        street: filters.values.street
                    }),
                    ...(filters.values?.zip && {
                        zip: filters.values.zip
                    }),
                },
                metric: {
                    ...(filters.values?.fuel && {
                        fuel: filters.values.fuel
                    }),
                    ...(filters.values?.mpg && {
                        mpg: filters.values.mpg
                    }),
                    ...(filters.values?.rpm && {
                        rpm: filters.values.rpm
                    }),
                    ...(filters.values?.speed && {
                        speed: filters.values.speed
                    }),
                    ...(filters.values?.volts && {
                        volts: filters.values.volts
                    }),
                },
                ...(filters.device && {
                    device: Object.keys(filters.device)
                }),
                ...(filters.person && {
                    people: Object.keys(filters.person)
                }),
                ...(filters.tag && {
                    tag: Object.keys(filters.tag)
                }),
                ...(filters.alerts && {
                    alerts: Object.keys(filters.alerts).map(alert => formatAlertWithHas(alert))
                }),
                ...(filters.labels && {
                    label: Object.keys(filters.labels)
                }),
                startDate: moment(report.dates[0].startDate).unix(),
                endDate: moment(report.dates[0].endDate).unix(),
                clientId: clientId,
                page,
            }

            try {
                let formattedPoints: any = [];
                const { data } = await instance.post(URL, { ...body });

                Object.values(data.content).map((point: any) => {
                    formattedPoints[point.pointId] = makePointFromEndpointData(point)
                })

                await dispatch(ReportActions.SET_DISPLAY_RECORDS(formattedPoints))

                this.setState({ loading: false })
                return data;
            } catch ({ message }) {
                this.setState({ loading: false })
                console.error(message)
            }
        }

        const getDevicesWithoutTripsRequest = async (
            startTime: number,
            endTime: number,
            accessToken: string
        ): Promise<string[]> => {

            const { selectedDevices } = this.props;

            const naturalSort = (a, b, order = "asc") => {
                const collator = new Intl.Collator(undefined, {
                    numeric: true,
                    sensitivity: "base"
                });

                const labelA = typeof a === "string" ? a : a?.label || "";
                const labelB = typeof b === "string" ? b : b?.label || "";

                const cleanedA = labelA.trim().replace(/\s+/g, " ");
                const cleanedB = labelB.trim().replace(/\s+/g, " ");

                const comparison = collator.compare(cleanedA, cleanedB);
                return order === "asc" ? comparison : -comparison;
            };

            const mapDevicesObjectToLabelValue = (devicesObject) => {
                return Object.keys(devicesObject)
                    .map(key => ({
                        label: devicesObject[key].name,
                        value: key
                    }))
                    .sort((a, b) => naturalSort(a, b, "asc"));
            };

            const devicesListSelect = mapDevicesObjectToLabelValue(devicesDetails.toObject());
            const firebaseDeviceIds =
                Object.keys(selectedDevices || {}).length === 0
                    ? devicesListSelect.map(d => d.value)
                    : Object.keys(selectedDevices);

            try {
                const res = await fetch(`${process.env.REACT_APP_API_URL}/api/firestore/get-devices-without-trips`, {
                    method: 'POST',
                    headers: {
                        Accept: 'application/json',
                        'Content-Type': 'application/json',
                        'Access-Token': accessToken,
                    },
                    body: JSON.stringify({
                        startTime,
                        endTime,
                        organizationKey: localStorage.get('active-client'),
                        firebaseDeviceIds,
                    }),
                });

                if (res.ok) {
                    const result = await res.json();
                    return result.data?.deviceIds || [];
                } else {
                    return [];
                }
            } catch (error) {
                return [];
            }
        };

        const getTripsFromBackend = async () => {
            if (this.state.cancelTokenSource) {
                this.state.cancelTokenSource.cancel('Operation canceled due to new request');
            }

            const cancelTokenSource = axios.CancelToken.source();
            const requestId = Date.now();
            this.setState({ cancelTokenSource, lastRequestId: requestId });

            const URL = `/api/firestore/trip`;
            const allTripsURL = `/api/firestore/trip-report`;
            const clientId = localStorage.get('active-client');
            const startFrom = this.state.travelLastDocs[this.state.travelCurrentPage];

            if (startFrom === this.state.prevStartFrom && report.searchKey === this.state.prevSearchKey) return;
            this.setState({prevStartFrom: startFrom});

            const body = {
                ...(filters.device && {
                    firebaseDeviceIds: Object.keys(filters.device)
                }),
                ...(filters.person && {
                    people: Object.keys(filters.person)
                }),
                ...(filters.tag && {
                    firebaseTagIds: Object.keys(filters.tag)
                }),
                ...(filters.alerts && {
                    alert: Object.keys(filters.alerts).map(alert => formatAlertWithHas(alert))
                }),
                ...(filters.labels && {
                    labels: Object.keys(filters.labels)
                }),
                ...((this.props.tripsFromSelectedArea.uniqueTripPath.length > 0) && {
                    firebaseTripIds: this.props.tripsFromSelectedArea.uniqueTripPath
                }),
                startTime: moment(report.dates?.[0]?.startDate ?? Date.now()).unix(),
                endTime: moment(report.dates?.[0]?.endDate ?? Date.now()).unix(),
                organizationKey: clientId,
                startAfterDoc: startFrom,
                limit: 20
            }

            const allTripsBody = {
                startTime: moment(report.dates?.[0]?.startDate ?? Date.now()).unix(),
                endTime: moment(report.dates?.[0]?.endDate ?? Date.now()).unix(),
                organizationKey: clientId,
                ...(filters.tag && {
                    firebaseTagIds: Object.keys(filters.tag)
                }),
                ...(filters.device && {
                    firebaseDeviceIds: Object.keys(filters.device)
                }),
                ...(filters.alerts && {
                    alert: Object.keys(filters.alerts).map(alert => formatAlertWithHas(alert))
                }),
            }

            try {
                const formattedTrips: any = [];

                const { data } = await instance.post(URL, { ...body }, { cancelToken: cancelTokenSource.token });
                const { data: allTripsData } = await instance.post(allTripsURL, { ...allTripsBody });
                if (this.state.lastRequestId !== requestId) return;

                if (allTripsData?.data) {
                    await dispatch(ReportActions.SET_TRAVEL_TRIP_IDS(allTripsData.data));
                }

                this.setState({ travelIsLastPage: data.isLastPage });

                if (data.lastDoc) {
                    this.setState({
                        travelLastDocs: {
                            ...this.state.travelLastDocs,
                            [this.state.travelCurrentPage + 1]: data.lastDoc
                        }
                    });
                }

                const records = data.results || [];
                records.forEach(trip => {
                    formattedTrips[trip.id] = {
                        ...makeTripFromEndpointData(trip.data),
                        tripId: trip.id,
                    };
                });
                const startTime = body.startTime;
                const endTime = body.endTime;

                const devicesWithoutTrips = await getDevicesWithoutTripsRequest(startTime, endTime, this.props.accessToken);

                devicesWithoutTrips.forEach(deviceId => {
                    formattedTrips[`no-trip-${deviceId}`] = {
                        tripId: null,
                        device: deviceId,
                        miles: 0,
                        mpg: 0,
                        maxSpeed: 0,
                        averageSpeed: 0,
                        idleMinutes: 0,
                        stopMinutes: 0,
                        pointCount: 0,
                        safetyPercent: 0,
                        alertActivity: {
                            exitCount: 0,
                            haspoweron: 0,
                            haspoweroff: 0,
                            sosCount: 0,
                            poweroffCount: 0,
                        }
                    };
                });
                await dispatch(ReportActions.SET_DISPLAY_RECORDS(formattedTrips));

                this.setState({ loading: false, cancelTokenSource: null });

            } catch ({ message }) {
                this.setState({ loading: false });
                console.error(message);
            }
        }

        const fetchStaticDevices = async () => {
            let devices: string[] = [];

            if (filters.tag) {
                for (const tag of Object.keys(filters.tag)) {
                    const tagDevices = await getDevicesFromTag(tag);

                    devices.push(...tagDevices);
                }

                const deviceSet = new globalThis.Set(devices);
                devices = [...deviceSet];
            }
            else if (filters.device) {
                devices = [...Object.keys(filters.device)];
            }

            const allDeviceIds = Object.keys(this.props.devicesDetails.toObject());

            return devices.length > 0 ? devices : allDeviceIds;
        }

        const newGetPoints = async () => {
            try {
                const res = await newGetPointsFromBackend();

                this.setState({
                    staticMaxDay: res
                });
            } catch (e) {
                console.error('Error in newGetPoints:', e);
            }
        };

        const getMileageRecords = async () => {
            const URL = '/api/location/get-miles-per-state';
            const clientId = localStorage.get('active-client');
            const deviceKeys = filters.device ? Object.keys(filters.device) : [];
            const tagKeys = filters.tag ? Object.keys(filters.tag) : [];
            const startTime = moment(report.dates?.[0]?.startDate ?? Date.now()).unix();
            const endTime = moment(report.dates?.[0]?.endDate ?? Date.now()).unix();

            const body = {
                "organization_key": clientId,
                "start_time": startTime,
                "end_time": endTime
            }

            const allDeviceIds = [];

            if (deviceKeys.length > 0) {
                allDeviceIds.push(...deviceKeys);
            }
            else if (tagKeys.length > 0) {
                const devicesFromTags = [];

                for (const tag of tagKeys) {
                    const tagDevices = await getDevicesFromTag(tag);

                    devicesFromTags.push(...tagDevices)
                }

                allDeviceIds.push(...Array.from(new Set(devicesFromTags)));
            }
            else {
                allDeviceIds.push(...Object.keys(devicesDetails.toObject()))
            }

            body['device_ids'] = allDeviceIds.slice(0, 3);

            await dispatch(ReportActions.SET_MILEAGE_DEVICE_IDS(allDeviceIds));
            await dispatch(ReportActions.SET_MILEAGE_START_DATE(startTime));
            await dispatch(ReportActions.SET_MILEAGE_END_DATE(endTime));

            try {
                const { data } = await instance.post(URL, {...body})
                await dispatch(ReportActions.SET_DISPLAY_RECORDS(Object.values(data)));
            } catch (e) {
                console.log(e)
            }

            this.setState({
                loading: false,
                mileageDevices: allDeviceIds,
                mileageClient: clientId,
                mileageStartDate: startTime,
                mileageEndDate: endTime
            });
        }

        const getPointsOrIncreasePage = async () => {
            try {
                let pageHasData = false;

                const data = await getPointsFromBackend(this.state.currentPage);

                if (Object.keys(data.content).length) {
                    pageHasData = true;
                }

                this.setState(prevState => {
                    return {
                        ...prevState,
                        pages: pageHasData ? [...prevState.pages, data.currentPage] : [...prevState.pages],
                        currentPage: data.currentPage,
                        isHaveNext: data.nextPage,
                    }
                })
            } catch ({ message }) {
                console.error(message);
            }
        }

        const getAudit = async () => {
            if (!ACL.check(UserCan.DO_ANYTHING, this.props.userCanDo, true)) {
                this.setState({ loading: false })
                return;
            }

            const auditLog = await getAuditLog();

            this.setState({ auditLog: getFilteredData(auditLog, report.filters, report.dates), loading: false })
        }

        let query: iGetReportPropsWrapper = {
            allTags: tags,
            filters: report.filters,
            dates: report.dates,
            devicesDetails,
        };

        // dispatch(ReportAC.fetchDevicePing(query, userToken?.devices || false));
        // don't forget that trips that have start dates before the search start date
        // can happend since the trip end date may be within range.
        if (report.reportType === 'travel') {
            getTripsFromBackend();
        } else if (report.reportType === 'summary') {
            const trips = await getTrips(query, userToken?.devices || false);
            dispatch(ReportActions.SET_DISPLAY_RECORDS(trips));
            this.setState({ loading: false })
        } else if (report.reportType === 'static') {
            // getPointsOrIncreasePage();
            newGetPoints();
        } else if (report.reportType === "geofence") {
            let pointsWithGeofences = await getGeonfeces(query, userToken?.devices || false);
            dispatch(ReportActions.SET_DISPLAY_RECORDS(pointsWithGeofences));
            this.setState({ loading: false })
        } else if (report.reportType === 'time-clock') {
            const trips = await getTrips(query, userToken?.devices || false);
            dispatch(ReportActions.SET_DISPLAY_RECORDS(props.selectionsList.length > 0 && validate(props.selectionsList) ? filterRecords(props.selectionsList, trips) : trips));
            this.setState({ loading: false });
        }  else if (report.reportType === 'video') {
            let deviceFilters = [];
            let tagFilters = [];
            const clientId = localStorage.get('active-client');
            const url = '/api/device/video-download-report';

            if (filters.device ) deviceFilters = Object.keys(filters.device);
            if (filters.tag) tagFilters = Object.keys(filters.tag);

            const currentDate = moment();

            const startDate = report.dates && report.dates[0] ? moment(report.dates[0].startDate) : currentDate.startOf('day');
            const endDate = report.dates && report.dates[0] ? moment(report.dates[0].endDate) : currentDate.endOf('day');

            const startTime = startDate.unix().toString();
            const endTime = endDate.unix().toString();

            const body = {
                orgKey: clientId,
                startTime,
                endTime
            }

            if (deviceFilters.length > 0) {
                body['deviceIds'] = deviceFilters;
            }
            else if (deviceFilters.length === 0) {
                body['deviceIds'] = Object.keys(devicesDetails.toObject());
            }

            if (tagFilters.length > 0) {
                body['tagIds'] = tagFilters;
            }

            try {
                const { data } = await instance.post(url, { ...body });
                const totalCount = Number(data.totalCount);

                dispatch(ReportActions.SET_DISPLAY_RECORDS(data.data));

                this.setState({
                    videoTotalCount: totalCount,
                    videoRequestBody: body
                })
            } catch (error) {
                console.error(error)
            }

            this.setState({ loading: false });
        } else if (report.reportType === 'permissions') {
            const persons = filters.person ? Object.keys(filters.person) : Object.keys(this.props.people);

            const records = await getPermissionsForUsers(persons.slice(0, 10));

            dispatch(ReportActions.SET_DISPLAY_RECORDS(records));
            dispatch(ReportActions.SET_PERMISSION_PERSONS(persons));

            this.setState({ loading: false });
        } else if (report.reportType === 'audit-log') {
            getAudit();
        } else if (report.reportType === 'activity') {
            let ids = [];

            if (filters.device ) {
                const deviceFilters = Object.keys(filters.device);
                ids = [...deviceFilters];
            }
            else if (filters.tag) {
                const setOfIds = new Set();
                const tagFilters = Object.keys(filters.tag);

                for (const tag of tagFilters) {
                    const tagDevicesSnapshot = await clientDb().child(`tags/${tag}/instances/device`).once('value');
                    const tagDevices = tagDevicesSnapshot.val() ? Object.keys(tagDevicesSnapshot.val()) : [];

                    for (const tagDevice of tagDevices) {
                        setOfIds.add(tagDevice);
                    }
                }

                ids = Array.from(setOfIds);
            }
            else {
                ids = Object.keys(devicesDetails.toObject());
            }

            const sortedRecords = await getActivityReports(ids);

            await dispatch(ReportActions.SET_DISPLAY_RECORDS(sortedRecords));

            this.setState({ loading: false });
        } else if (report.reportType === 'mileage') {
            await getMileageRecords();
        }
    }

    staticPageClick = ({ next, previous }) => {
        if (next) {
            this.setState(prevState => {
                return {
                    ...prevState,
                    currentPage: prevState.currentPage + 1,
                }
            })
        };

        if (previous) {
            this.setState(prevState => {
                const prevPage = prevState.pages[prevState.pages.length - 2];

                if (!prevPage) {
                    return {
                        ...prevState,
                        currentPage: 1,
                        pages: [],
                    }
                }

                return {
                    ...prevState,
                    currentPage: prevPage,
                    pages: prevState.pages.slice(0, prevState.pages.length - 2)
                }
            })
        };

        setTimeout(() => {
            this.populateData(this.props);
        }, 100);
    }


    async componentDidMount() {
        const { dispatch, report, reportType } = this.props;
        const initializeReportType = () => {
            if (report.reportType !== reportType) {
                dispatch(ReportActions.SET_TYPE(reportType));
            }
        };

        const loadReportDataFromLocalStorage = () => {
            const localStorageKey = `matt-report-dev-${reportType}`;
            const storedReport = localStorage.get<iReportState>(localStorageKey);

            if (storedReport) {
                storedReport.details.dates = storedReport.details.dates.map(({ startDate, endDate }) => ({
                    startDate: moment(startDate),
                    endDate: moment(endDate),
                }));

                setTimeout(() => dispatch({ type: 'GEN_SET', val: storedReport, path: ['report'] }), 100);
            }
        };

        const populateDataIfNeeded = () => {
            if (report.searchKey || report.reportSearchKey) {
                this.populateData(this.props);
            }
        };

        initializeReportType();

        loadReportDataFromLocalStorage();

        populateDataIfNeeded();

        dispatch(ReportActions.CANCEL_CELL_PICKER());
        dispatch(ReportActions.TOGGLE_ITEM_FILTER('types', 'travel'));

    }

    componentWillUnmount(): void {
        this.props.dispatch(ReportActions.SET_TYPE('travel'));
        this.props.dispatch({
            type: "REPORT_SET_DISPLAY_RECORDS",
            displayRecords: {},
        });

        this.props.dispatch({
            type: "SET_DISPLAY_POINTS",
            records: {}
        });

        // reset filters
        this.props.dispatch(ReportActions.RESET_ALL_FILTERS());
        this.props.dispatch(ReportActions.RESET_DATES());
    }
    componentDidUpdate(prevProps, prevState) {
        const { report, dispatch, tripsFromSelectedArea, dates } = this.props;
        const { records, reportData } = this.state;

        if (report.reportType === 'static' && report.searchKey !== prevProps.report.searchKey) {
            this.setState({
                staticCurrentDay: 1,
                staticMaxDay: null,
                staticCurrentPage: 1,
                staticMaxPage: null,
                staticLimitPerPage: 20,
                staticDirection: true,
                staticCurrentDeviceIdx: 0,
            }, () => {
                this._clearRecords();
                this.populateData(this.props);
            });
        }

        if (report.reportType !== 'static' && report.searchKey !== prevProps.report.searchKey){
            this.setState({
                prevStartFrom: '',
                prevSearchKey: '',
                travelLastDocs: {1: null},
                travelCurrentPage: 1,
                travelIsLastPage: false
            });
        };

        if (prevProps.report !== report || prevState.records !== records || prevState.reportData !== reportData) {
            dispatch(GMapModalAC.setParams({ params: { records, reportData, report } }))
        }

        if (this.props.filters !== prevProps.filters) {
            this.setState(prevState => {
                return {
                    ...prevState,
                    currentPage: 1,
                }
            })
        }

        if (tripsFromSelectedArea.uniqueTripPath.length && !compareArrays(tripsFromSelectedArea.uniqueTripPath, prevProps.tripsFromSelectedArea.uniqueTripPath)){
            this.populateData(this.props);
        }
    }

    fetchHideLargeReportWarning = async () => {
        try {
          const value = await getHideLargeReportWarning();
          this.setState(prevState => {
            return {
                ...prevState,
                showLargeReportWarning: !value
            }
          });
        }
        catch (error) {
          console.error('Error fetching large report warning state', error);
        }
      }

    private choiceUpdate = async (setVal) => {
        const { dispatch, displayRecords, choosing } = this.props;

        if (!choosing) return;

        const oldRecord = idValArr(displayRecords).filter(recordMatches(choosing.affectedRowCriteria))[0].val;
        const oldVal = choosing.pickType === 'personId' ? oldRecord.personId : oldRecord.label;

        // optimistic update
        dispatch(ReportActions.UPDATE_DISPLAY_RECORDS_MATCHING(choosing.affectedRowCriteria, choosing.pickType, setVal));
        dispatch(ReportActions.CANCEL_CELL_PICKER());

        try {
            await choosing.updater(setVal);
        } catch (e) {
            console.log(e);
            dispatch(ReportActions.UPDATE_DISPLAY_RECORDS_MATCHING(choosing.affectedRowCriteria, choosing.pickType, oldVal));

            this.dialog?.({
                title: 'Problem encountered',
                body: 'An unexpected problem was encountered while changing the assigment. We had to change it back. If you continue to encounter this problem please notify us.',
                type: 'NOTIFICATION',
            });
        }
    }

    setupDialog = (callBack: () => DialogConfigSetter): void => {
        this.dialog = callBack();
    }

    async componentWillReceiveProps(props) {
        if (this.props.report.searchKey !== props.report.searchKey) {
            this.populateData(props);
        }

        if (props.report.reportType !== props.reportType) {
            this.props.dispatch(ReportActions.SET_TYPE(props.reportType));
        }
    }

    _clearRecords = () => {
        this.props.dispatch({ type: 'REPORT_SET_DISPLAY_RECORDS', displayRecords: {} });
    }

    saveReport = () => {
        const { records, reportData } = this.state;
        const { report } = this.props

        const pdf = new jsPDF();
        const devices = Object.keys(records)

        devices.map((item, index) => {
            if (report.reportType === 'travel') {
                records[item].map((row) => {
                    const deviceOffset = utcOffset(reportData[item].deviceTimezone, moment().isDST());
                    const diff = userCurrentOffset - deviceOffset;
                    const start = moment(row.startDate).subtract(diff, 'hours');
                    const end = moment(row.endDate).subtract(diff, 'hours');

                    autoTable(pdf, {
                        head: [[reportData[item].name, start.format('M/D/YY'), '', `${start.format('h:mmA')} - ${row.startAddress}`]],
                        body: [
                            ['', 'Duration:', friendlyDiff(moment(row.endDate), moment(row.startDate))],
                            ['', 'Idle:', minutesToFriendly(row.idleMinutes)],
                            ['', 'Stopped:', minutesToFriendly(row.stopMinutes)],
                            ['', 'Safety:', row.safetyPercent ? row.safetyPercent + '%' : 'NA'],
                            ['', 'Avg. Speed:', `${row.averageSpeed ? friendlySpeed(row.averageSpeed, reportData[item].deviceUnits) : 'NA'}`],
                            ['', 'Consumption:', friendlyMilesPer(row.mpg, reportData[item].deviceUnits)],
                        ],
                        foot: [['', '', '', `${end.format('h:mmA')} - ${row.endAddress}`]]
                    })
                })
            }
            if (report.reportType === 'static') {
                const data = records[item].map((row) => {
                    const deviceOffset = utcOffset(reportData[item].deviceTimezone, moment().isDST());
                    const diff = userCurrentOffset - deviceOffset;
                    const dateWithCorrection = moment(row.time).subtract(diff, 'hours');

                    return [dateWithCorrection.format('MMM-D'), dateWithCorrection.format('h:mmA'), row.fuel, row.speed, row.posted_speed, row.mpg,
                    `${row.address.street} ${row.address.city} ${row.address.state} ${row.address.zip}`.replace(/US/gi, ''),
                    `${row.coordinates.location['lat']}, ${row.coordinates.location['lng']}`,
                    ];
                })

                autoTable(pdf, {
                    theme: 'grid',
                    headStyles: { fillColor: '#2E80BA' },
                    head: [[reportData[item].name, 'Data', 'Fuel', 'mph', 'Posted', 'mpg', 'Location', 'Coordinates']],
                    body: data,
                })
            }
        })

        pdf.save('Report.pdf')
    }

    debugRender = () => {
        const { report, dispatch, labels, people, devicesDetails, displayRecords, choosing, reportType, userCanDo, dates, filters, selectedDevices, size } = this.props;
        const { loading, disablePaginateButton, records, reportData, showVisibleReportData, showVisibleFencesData } = this.state;
        const activeIdx = ['static', 'travel', 'scheduled', 'queue'].indexOf(report.reportType as any);
        const loginToken = localStorage.get('login-init-be-token');
        const noDataIndicator = this.state.isLongReport || !report.searchKey || this.state.loading || lCount(displayRecords) > 0;
        const smallDashboardSize = size === DashboardSize.OPEN_SMALL;

        let overlay;
        if (choosing && choosing.pickType === 'label')
            overlay =
                <Overlay header="Select label" close={pipe(ReportActions.CANCEL_CELL_PICKER, dispatch) as any}>
                    <LabelChooser type="trip" canAdd choose={this.choiceUpdate} items={labels.map(l => ({ id: l, content: l }))} />
                </Overlay>
        if (choosing && choosing.pickType === 'personId')
            overlay =
                <Overlay close={pipe(ReportActions.CANCEL_CELL_PICKER, dispatch) as any}>
                    <LabelChooser
                        type="person"
                        items={vals(people).map(p => ({
                            id: p.id, content: <div style={{ color: '#000' }}>
                                <PersonBox compressed personId={p.id} person={p} active={false} />
                            </div>
                        }))}
                        choose={this.choiceUpdate} />
                </Overlay>

        const seeAllReports = ACL.check(UserCan.SEE_ALL_REPORTS, userCanDo);
        const isAdmin = ACL.check(UserCan.DO_ANYTHING, userCanDo, true);
        const showSummaryModal = !isMobile && seeAllReports && report.searchKey && this.props.reportType !== 'audit-log'
        const startDate = moment.min(report.dates.map(d => d.startDate));
        const endDate = moment.max(report.dates.map(d => d.endDate));

        const openBottomShadowModal = () => dispatch(GMapModalAC.showModal({ contentType: GMapModalContent.AVERAGE_VALUES }));

        const handleExport = () => dispatch(GMapModalAC.showModal({ contentType: GMapModalContent.EXPORT_REPORT, params: { report, records, reportData } }));
        const handleFilters = () => dispatch(GMapModalAC.showModal({ contentType: GMapModalContent.REPORT_PAGE_FILTERS }));

        const handleClick = (element) => {
            this._clearRecords();
            dispatch(ReportActions.SET_TYPE_FROM_REDUX(element));
        }

        const bothDeviceDisabled = this.state.staticCurrentDeviceIdx === 0 && (this.state.staticCurrentDeviceIdx >= (this.state.staticDevices.length - 1)) || this.state.staticDevices.length === 0

        const staticNextPage = () => {
            this.setState({
                staticCurrentPage: this.state.staticCurrentPage + 1,
                isStaticDayPagination: false
            }, () => {
                this.populateData(this.props);
            })
        }

        const staticPreviousPage = () => {
            this.setState({
                staticCurrentPage: this.state.staticCurrentPage - 1,
                isStaticDayPagination: false
            }, () => {
                this.populateData(this.props);
            })
        }

        const staticNextDay = () => {
            this.setState({
                staticCurrentDay: this.state.staticCurrentDay + 1,
                staticCurrentPage: 1,
                staticDirection: true,
                isStaticDayPagination: true
            }, () => {
                this.populateData(this.props);
            })
        }

        const staticPreviousDay = () => {
            this.setState({
                staticCurrentDay: this.state.staticCurrentDay - 1,
                staticCurrentPage: 1,
                staticDirection: false,
                isStaticDayPagination: true
            }, () => {
                this.populateData(this.props);
            })
        }

        const staticNextDevice = () => {
            this.setState({
                staticCurrentDeviceIdx: this.state.staticCurrentDeviceIdx + 1,
                staticCurrentDay: 1,
                staticCurrentPage: 1,
                isStaticDayPagination: false
            }, () => {
                this.populateData(this.props);
            })
        }

        const staticPreviousDevice = () => {
            this.setState({
                staticCurrentDeviceIdx: this.state.staticCurrentDeviceIdx - 1,
                staticCurrentDay: 1,
                staticCurrentPage: 1,
                isStaticDayPagination: false
            }, () => {
                this.populateData(this.props);
            })
        }

        const staticCurrentDeviceId = this.state.staticDevices[this.state.staticCurrentDeviceIdx] || null;

        const clearFilters = () => {
            dispatch(ReportActions.RESET_ALL_FILTERS());
            dispatch(ReportActions.RESET_DATES());
        }


          const handleCloseReports = () => {
            dispatch(ReportActions.RESET_ALL_FILTERS());
            dispatch(ReportActions.RESET_DATES());
            this.props.history.push('/device')
          }

        const  handleChangeUnstagedDate = (newDate) => {
            this.setState({ dateUnstaged: newDate });
        };

        const handleChangeTimeEnd = (endTimeDate) => {
            this.setState({ timeEnd: endTimeDate });
        }

        const handleApplyFilterReports = () => {
            dispatch(GMapModalAC.hideModal());

            const { dateUnstaged } = this.state;

            if (!dateUnstaged || dateUnstaged.length === 0) {
                // Handle the case when dateUnstaged is empty or undefined
                return;
            }

            const { startDate, endDate } = dateUnstaged[0];
            this.setState({datesState: {isDirty: true}})

            if (!startDate?.isValid() || !endDate?.isValid()) {
                return;
            } else {
                dispatch(ReportActions.SET_START_DATE(startDate));
                dispatch(ReportActions.SET_END_DATE(endDate));
                handleChangeUnstagedDate([]);
            }
        }

        const showStartDateError = this.state.datesState.isDirty && this.state.dateUnstaged.length && !this.state.dateUnstaged[0]?.startDate?.isValid();
        const showEndDateError = this.state.datesState.isDirty && this.state.dateUnstaged.length && !this.state.dateUnstaged[0]?.endDate?.isValid();


        const naturalSort = (a, b, order = "asc") => {
            const collator = new Intl.Collator(undefined, {
              numeric: true,
              sensitivity: "base"
            });

            const labelA = typeof a === "string" ? a : a?.label || "";
            const labelB = typeof b === "string" ? b : b?.label || "";

            const cleanedA = labelA.trim().replace(/\s+/g, " ");
            const cleanedB = labelB.trim().replace(/\s+/g, " ");

            const comparison = collator.compare(cleanedA, cleanedB);
            return order === "asc" ? comparison : -comparison;
        };

        const mapDevicesObjectToLabelValue = (devicesObject) => {
        return Object.keys(devicesObject)
            .map(key => ({
            label: devicesObject[key].name,
            value: key
            }))
            .sort((a, b) => naturalSort(a, b, "asc"));
        };

        const devicesListSelect = mapDevicesObjectToLabelValue(devicesDetails.toObject());

        const setDevice = (id: string) => {
            if (selectedDevices[id]) {
                dispatch(ReportActions.TOGGLE_ITEM_FILTER(FilterType.DEVICES, id));
              } else {
                dispatch(ReportActions.RESET_ALL_TYPE_FILTERS(FilterType.DEVICES));
                dispatch(ReportActions.TOGGLE_ITEM_FILTER(FilterType.DEVICES, id));
              }
        }

        const selectedListOption = Object.values(devicesListSelect).find(deviceObject => deviceObject.value === Object.keys(selectedDevices)[0]);

        // Check if any trips are visible for showing ReportTripDetailsModal
        const hasVisibleTrips = () => {
            return this.props.devicesTripsPoints.some(deviceTrips => {
                const reportTripsIds = deviceTrips.get('reportTripsIds');
                return reportTripsIds && reportTripsIds.some(show => show === true);
            });
        };

        const showTripDetailsModal = hasVisibleTrips() && !this.state.isShowingAllTrips;

        const showTravelPagination = this.props.reportType === "travel" &&
                             !!this.state.allTrips.length &&
                             lCount(displayRecords) > 0;

        const showAllTripsButton = this.props.reportType === 'travel'
            && report.searchKey
            && !loading
            && lCount(displayRecords) > 0;

        const tripsWithIdCount = idValArr(displayRecords).filter(({ val }) => !!val.tripId).length;
        const totalTripsWithIdCount = Array.isArray(this.props.travelTripIds)
            ? Array.from(new NativeSet(this.props.travelTripIds)).length
            : 0;

        return (
            <>
                <DashboardBlock title="Reports" overlay={
                    <>
                        {overlay}
                        {showTripDetailsModal && <ReportTripDetailsModal />}
                        {showSummaryModal && (
                            <LocalModalActions
                                userCanDo={userCanDo}
                                seeAllReports={seeAllReports}
                                records={records}
                                reportData={reportData}
                                report={report}
                            />
                        )}
                    </>
                }>
                    {this.state.isLongReport &&  <LongReportModal
                      onClose={this.state.popupCloseHandler}
                      onProceed={this.state.popupProceedHandler}
                    />}
                    <ModalHeaderComponent
                        title={`${reportType} Report`}
                        goBackCallback={clearFilters}
                        action={{icon: <CloseIcon style={{position: 'absolute', top: 0, left: 0}} />, title: 'Close reports and go to devices page', click: handleCloseReports}}
                        paginateComponent={
                            <Button
                                styleType={ButtonStyles.ORANGE_WHITE}
                                size={ButtonSize.SM}
                                onClick={handleFilters}
                            >
                                <span className="align-center"><FilterListSvg className="icon-md" style={{ marginRight: "4px" }} />Report Filters</span>
                            </Button>
                        }
                    />
                    <ReportNavbar />

                    <div className={`report-page-container ${showTripDetailsModal ? 'has-trip-modal' : ''}`}>
                        <section className={classNames('travelReportHeader', { smallDashboardSize })}>
                            <div className='deviceSelect'>
                                <div className="deviceTitle">
                                    <label className="dateLabel">Device:</label>
                                </div>
                                <Select
                                    key="devicesSearch"
                                    isMulti
                                    onChange={(selectedOptions) => {
                                        const ids = (selectedOptions || []).map((opt) => opt.value);
                                        dispatch(ReportActions.RESET_ALL_TYPE_FILTERS(FilterType.DEVICES));
                                        ids.forEach((id) => {
                                            dispatch(ReportActions.TOGGLE_ITEM_FILTER(FilterType.DEVICES, id));
                                        });
                                    }}
                                    value={devicesListSelect.filter(opt =>
                                        Object.keys(selectedDevices).includes(opt.value)
                                    )}
                                    styles={{
                                        ...customSelectStyles,
                                        container: (provided) => ({
                                            ...provided,
                                            width: '100%',
                                        }),
                                        valueContainer: (provided) => ({
                                            ...provided,
                                            maxHeight: 100,
                                            overflowY: 'auto',
                                        }),
                                        indicatorsContainer: (provided, state) => ({
                                            ...provided,
                                            alignSelf: state.hasValue ? 'flex-start' : 'center',
                                        }),
                                    }}
                                    options={devicesListSelect}
                                />
                            </div>
                            <div className='datePickers'>
                                <div className="datePicker">
                                    <label className="dateLabel">From:</label>
                                        <DateFilterTabs
                                            dates={this.state.dateUnstaged.length ? this.state.dateUnstaged: dates}
                                            type={DateChangeType.start}
                                            submitBtnTitle='Save'
                                            dateError={showStartDateError ? `Please provide start date` : null}
                                            changeUnstagedDate={handleChangeUnstagedDate}

                                        />
                                </div>
                                <div className="datePicker">
                                    <label className="dateLabel">To:</label>
                                    <DateFilterTabs
                                        dates={this.state.dateUnstaged.length ? this.state.dateUnstaged : dates}
                                        type={DateChangeType.end}
                                        submitBtnTitle='Save'
                                        changeUnstagedDate={handleChangeUnstagedDate}
                                        dateError={showEndDateError ? `Please provide end date` : null}

                                    />
                                </div>
                            </div>
                            <button
                                className='filterReports'
                                type='button'
                                onClick={handleApplyFilterReports}
                            >
                                Show Range
                            </button>
                        </section>



                        {/* !isFullModal ? null :
                            <Row justify="center">
                                <div className="inline-gmap-wrapper" style={{height: 250, width: 250, position: 'relative', marginTop: 20}}>
                                    <GMaps />
                                </div>
                            </Row>
                        */}
                        {/* Table */}
                        {(!report.searchKey) ? <FilterPromptBlock /> :
                            <div className="report-tables"  >
                                {showAllTripsButton && tripsWithIdCount > 0 && (
                                    <div className="show-all-trips-row">
                                        {this.state.isShowingAllTrips ? (
                                            <button
                                                className="show-all-trips-btn show-all-trips-btn--hide"
                                                onClick={this.hideAllTrips}
                                            >
                                                Hide All Trips
                                            </button>
                                        ) : (
                                            <div className="show-all-trips-split-btn-container">
                                                <button
                                                    className="show-all-trips-btn show-all-trips-btn--show show-all-trips-btn--split-main"
                                                    onClick={() => this.showAllTrips(this.state.showAllTripsScope)}
                                                    disabled={this.state.isLoadingAllTrips}
                                                >
                                                    {this.state.isLoadingAllTrips
                                                        ? <><Fa icon={faSpinner} spin /> Loading...</>
                                                        : `Show Trips - ${this.state.showAllTripsScope === 'page' ? `Current Page (${tripsWithIdCount})` : `Full Result Set (${totalTripsWithIdCount})`}`
                                                    }
                                                </button>
                                                {totalTripsWithIdCount > tripsWithIdCount && (
                                                    <>
                                                        <div className="show-all-trips-btn--split-divider" />
                                                        <button
                                                            className="show-all-trips-btn show-all-trips-btn--show show-all-trips-btn--split-arrow"
                                                            onClick={() => this.setState({ showAllTripsDropdownOpen: !this.state.showAllTripsDropdownOpen })}
                                                            disabled={this.state.isLoadingAllTrips}
                                                            aria-haspopup="menu"
                                                            aria-expanded={this.state.showAllTripsDropdownOpen}
                                                        >
                                                            ▼
                                                        </button>
                                                        {this.state.showAllTripsDropdownOpen && (
                                                            <div className="show-all-trips-dropdown-menu">
                                                                <button
                                                                    className="show-all-trips-dropdown-item"
                                                                    onClick={() => {
                                                                        this.setState({ showAllTripsScope: 'page', showAllTripsDropdownOpen: false });
                                                                    }}
                                                                >
                                                                    Current Page ({tripsWithIdCount})
                                                                </button>
                                                                <button
                                                                    className="show-all-trips-dropdown-item"
                                                                    onClick={() => {
                                                                        this.setState({ showAllTripsScope: 'result-set', showAllTripsDropdownOpen: false });
                                                                    }}
                                                                >
                                                                    Full Result Set ({totalTripsWithIdCount})
                                                                </button>
                                                            </div>
                                                        )}
                                                    </>
                                                )}
                                            </div>
                                        )}
                                    </div>
                                )}

                                {loading
                                    ? <div style={{ width: '100%', fontSize: 25, textAlign: 'center' }}><Fa icon={faSpinner} spin /></div>
                                    : this.props.reportType === "travel" || this.props.reportType === "time-clock" || this.props.reportType === 'permissions' ? (
                                        (<>
                                            {showTravelPagination && (
                                                <div className='travelPagination'>
                                                    {this.state.currentPage > 1 ? (
                                                            <button className={classNames({ 'paginateBtn': true })} onClick={() => this.pageClick({ next: false, previous: true, dates: dates, filters })}>
                                                                <ChevronLeft style={{ width: 23, height: 23 }} /> Previous
                                                            </button>
                                                        ) : (
                                                            <button disabled className={classNames({ 'paginateBtnDisabled': true })}>
                                                                <ChevronLeft style={{ width: 23, height: 23 }} /> Previous
                                                            </button>
                                                        )}

                                                    {this.state.isHaveNext === true ? (
                                                        <button className={classNames({ 'paginateBtn': true })} onClick={() => this.pageClick({ next: true, previous: false, dates: dates, filters })}>
                                                            Next <ChevronRight style={{ width: 23, height: 23 }} />
                                                        </button>
                                                    ) : (
                                                        <button disabled className={classNames({ 'paginateBtnDisabled': true })}>
                                                            Next <ChevronRight style={{ width: 23, height: 23 }} />
                                                        </button>
                                                    )}
                                                </div>
                                            )}
                                            <TripTravelTablePure
                                                showAllRoute={this.state.showAllRoute}
                                                setShowAllRoute={this.setShowAllRoute}
                                                getRecords={this.getRecords}
                                                getReportData={this.getReportData}
                                                showReportTrip={this.showReportTrip}
                                                hideReportTrip={this.hideReportTrip}
                                                isTimeClock={this.props.reportType === "time-clock"}
                                                showVisibleReportData={showVisibleReportData}
                                            />
                                            {this.props.reportType === "travel" && <div className="travel-report-pagination">
                                                {this.state.travelCurrentPage > 1 && lCount(displayRecords) > 0 &&
                                                  <button onClick={() => {
                                                      this.setState({travelCurrentPage: this.state.travelCurrentPage - 1}, () => {
                                                          this.populateData(this.props);
                                                      });
                                                  }}>Previous</button>}
                                                {!this.state.travelIsLastPage && lCount(displayRecords) > 0 &&
                                                  <button onClick={() => {
                                                      this.setState({travelCurrentPage: this.state.travelCurrentPage + 1}, () => {
                                                          this.populateData(this.props);
                                                      });
                                                  }}>Next</button>}
                                            </div>}
                                            {showTravelPagination && (
                                                <div className='travelPaginationBottom'>
                                                    {this.state.currentPage > 1 ? (
                                                        <button className={classNames({ 'paginateBtn': true })} onClick={() => this.pageClick({ next: false, previous: true, dates: dates, filters })}>
                                                            <ChevronLeft style={{ width: 23, height: 23 }} /> Previous
                                                        </button>
                                                    ) : (
                                                        <button disabled className={classNames({ 'paginateBtnDisabled': true })}>
                                                            <ChevronLeft style={{ width: 23, height: 23 }} /> Previous
                                                        </button>
                                                    )}

                                                    {this.state.isHaveNext === true ? (
                                                        <button className={classNames({ 'paginateBtn': true })} onClick={() => this.pageClick({ next: true, previous: false, dates: dates, filters })}>
                                                            Next <ChevronRight style={{ width: 23, height: 23 }} />
                                                        </button>
                                                    ) : (
                                                        <button disabled className={classNames({ 'paginateBtnDisabled': true })}>
                                                            Next <ChevronRight style={{ width: 23, height: 23 }} />
                                                        </button>
                                                    )}
                                                </div>
                                            )}
                                        </>)
                                    // static report
                                    ) : this.props.reportType === "static" ? (
                                        <>
                                            <TripTravelTablePure
                                                showAllRoute={this.state.showAllRoute}
                                                setShowAllRoute={this.setShowAllRoute}
                                                getRecords={this.getRecords}
                                                getReportData={this.getReportData}
                                                showReportTrip={this.showReportTrip}
                                                hideReportTrip={this.hideReportTrip}
                                                isTimeClock={false}
                                                showVisibleReportData={showVisibleReportData}
                                                staticNextPage={staticNextPage}
                                                staticPreviousPage={staticPreviousPage}
                                                staticCurrentPage={this.state.staticCurrentPage}
                                                staticMaxPage={this.state.staticMaxPage}
                                                staticNextDay={staticNextDay}
                                                staticPreviousDay={staticPreviousDay}
                                                staticCurrentDay={this.state.staticCurrentDay}
                                                staticMaxDay={this.state.staticMaxDay}
                                                staticNextDevice={staticNextDevice}
                                                staticPreviousDevice={staticPreviousDevice}
                                                staticCurrentDeviceIdx={this.state.staticCurrentDeviceIdx}
                                                staticCurrentDeviceId={staticCurrentDeviceId}
                                                staticDevicesLength={this.state.staticDevices.length}
                                            />
                                            {/*{!!this.state.pages.length && (*/}
                                            {/*    <div className='travelPaginationBottom'>*/}
                                            {/*        {this.state.currentPage !== this.state.pages[0]  ? (<button className={classNames({ 'paginateBtn': true })} onClick={() => this.staticPageClick({ next: false, previous: true })}><ChevronLeft style={{ width: 23, height: 23 }} /> Previous</button>)*/}
                                            {/*            : (<button disabled className={classNames({ 'paginateBtnDisabled': true })}><ChevronLeft style={{ width: 23, height: 23 }} /> Previous</button>)}*/}

                                            {/*        {this.state.isHaveNext === true ?*/}
                                            {/*            (<button className={classNames({ 'paginateBtn': true })} onClick={() => this.staticPageClick({ next: true, previous: false })}>Next <ChevronRight style={{ width: 23, height: 23 }} /></button>)*/}
                                            {/*            : (<button disabled className={classNames({ 'paginateBtnDisabled': true })}>Next <ChevronRight style={{ width: 23, height: 23 }} /></button>)}*/}
                                            {/*    </div>*/}
                                            {/*)}*/}
                                        </>
                                  ) : (this.props.reportType === 'geofence' ?
                                        <GeofenceReport showVisibleFencesData={showVisibleFencesData}/>
                                    : this.props.reportType === 'audit-log' ?
                                        <AuditReport data={this.state.auditLog}/>
                                    : this.props.reportType === 'video' ?
                                      <VideoReport
                                        totalCount={this.state.videoTotalCount}
                                        body={this.state.videoRequestBody}
                                      />
                                    : this.props.reportType === 'activity' ?
                                      <ActivityReport/>
                                    : this.props.reportType === 'mileage' ?
                                      <MileageReport
                                        clientId={this.state.mileageClient}
                                        startTime={this.state.mileageStartDate}
                                        endTime={this.state.mileageEndDate}
                                        allDevices={this.state.mileageDevices}
                                      />
                                    : <SummaryReport
                                        showReportTrip={this.showReportTrip}
                                        hideReportTrip={this.hideReportTrip}
                                      />
                                  )
                                }
                            </div>
                        }

                        {/* No data indicator */}
                        {noDataIndicator ? null :
                            <MinimalTile className="minimal-tile" style={{ marginTop: 10, textAlign: 'center' }}>
                                <p>No data was found for you filter criteria.</p>
                            </MinimalTile>
                        }
                    </div>
                </DashboardBlock>
                <Dialog setupConfig={this.setupDialog} />
                                    </>
        );
    }
}

export default compose(
  connect(mapStateToProps),
  withRouter,
  React.memo
)(ReportPage);

const FilterPrompt = connect(
    (s: iFullStoreState): { details: iReportDetails, gMapModal: iGMapModal } => ({ details: s.report.details, gMapModal: s.gMapModal })
)(({ details }: { details: iReportDetails, gMapModal }) => {
    const dispatch = useDispatch();
    const showReportFiltersModal = () => {
        dispatch(GMapModalAC.showModal({ contentType: GMapModalContent.REPORT_PAGE_FILTERS, params: { fullHeight: true } }));
    }

    useEffect(() => {
        return () => {
            dispatch(GMapModalAC.hideModal());
        }
    }, []);

    return (
        <Button
            styleType={ButtonStyles.BLACK_WHITE}
            size={ButtonSize.MD}
            onClick={showReportFiltersModal}
        >
            <span className={"align-center"}><FilterListSvg className="icon-md" style={{ marginRight: "5px" }} />Report Filters</span>
        </Button>
    )
});

const FilterPromptBlock = () => {
    return (
        <div className="report-filter-begin">
        </div>
    )
}

type IFilterIndicatorProps = {
    type: string;
    reportType: string;
}
type IFilterIndicatorPropsFromStore = {
    report: iReportDetails;
}

const FilterIndicatorItem: FC<{ className?: string }> = ({ children, className = "" }) => {
    const dispatch = useDispatch();
    const handleClick = () => dispatch(GMapModalAC.showModal({ contentType: GMapModalContent.REPORT_PAGE_FILTERS }));
    return (
        <Button
            className={`filter-indicator-item ${className}`}
            styleType={ButtonStyles.WHITE_GRAY}
            size={ButtonSize.SM}
            onClick={handleClick}
        >
            {children}
        </Button>
    )
}
